import React from 'react';
import Modal from 'react-modal';

// images
import greyX from '../../images/grey-x.svg';

function ApproveContractModal({ isOpen, toggleApproveContractModal, onSubmitApproveContractModal, contractId }) {
    const onSubmit = (message) => {
        onSubmitApproveContractModal(message)
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={toggleApproveContractModal}
            closeTimeoutMS={200}
            ariaHideApp={false}
            className='modal-contract__action'

        >
            <div className='modal-header'>
                <h2><b>Do you want to approve this contract?</b></h2>
                <button className='close' onClick={toggleApproveContractModal}>
                    <img src={greyX} alt="Close"/>
                </button>
            </div>
            <div className="modal-footer">
                <button
                    onClick={() => onSubmit('success')}
                    className='link__form-add'
                >
                    Yes
                </button>
                <button
                    onClick={() => onSubmit('error')}
                    className='link__form-add'
                >
                    No
                </button>
            </div>
        </Modal>
    );
};

export default ApproveContractModal;